export default __webpack_public_path__ + "static/media/header-18.95e9b421.jpg";